<app-modal #modal [modalConfig]="modalConfig">
  <button
    class="btn btn-closemodal"
    title="Close"
    aria-label="close"
    headerContent
    (click)="closeModal()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <form
    *ngIf="form"
    class="modal-content-padded"
    [formGroup]="form"
    (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="sessionTypeTitle" class="form-label fw-bold">
        Session Type Name <span class="text-danger">*</span>
      </label>
      <input
        id="sessionTypeTitle"
        type="text"
        class="form-control"
        formControlName="title"
        placeholder="e.g. Instructional Coaching Visit" />
    </div>

    <div class="mb-3">
      <label for="sessionTypeDescription" class="form-label fw-bold"
        >Description</label
      >
      <textarea
        id="sessionTypeDescription"
        class="form-control"
        formControlName="description"
        rows="3"
        placeholder="Briefly describe what this session type is used for…"></textarea>
    </div>

    <div class="form-check form-switch mb-3" *ngIf="canShowSharedToggle">
      <input
        id="sessionTypeShared"
        class="form-check-input"
        type="checkbox"
        role="switch"
        formControlName="isShared" />
      <label class="form-check-label fw-bold" for="sessionTypeShared"
        >Share Across All Districts</label
      >
      <p class="help-text mb-0">{{ sharedToggleHelpText }}</p>
    </div>

    <div class="mb-3">
      <span class="form-label fw-bold d-block">Layout</span>

      <div class="row g-2" *ngIf="!isEditMode">
        <div class="col-12 col-md-4" *ngFor="let option of layoutOptions">
          <button
            type="button"
            class="layout-card w-100 text-start"
            [class.selected]="form.get('layout')?.value === option.value"
            (click)="selectLayout(option.value)">
            <img
              class="layout-card-swatch"
              [src]="getLayoutThumbnail(option.value)"
              alt="" />
            <span class="layout-card-text">
              <span class="layout-card-label">{{ option.label }}</span>
              <span class="layout-card-description">{{
                option.description
              }}</span>
            </span>
          </button>
        </div>
      </div>

      <div
        class="contextual-info-box mt-2"
        [class.d-flex]="isEditMode"
        [class.gap-3]="isEditMode"
        *ngIf="selectedLayoutInfo">
        <img
          *ngIf="isEditMode"
          class="contextual-info-thumbnail"
          [src]="getLayoutThumbnail(form.get('layout')?.value)"
          alt="" />
        <div class="flex-grow-1">
          <p class="mb-1 fw-bold layout-category-label">
            {{ selectedLayoutInfo.category }}
          </p>
          <p class="mb-1 fw-semibold">{{ selectedLayoutInfo.summary }}</p>
          <p class="mb-2 fst-italic text-muted">
            e.g. {{ selectedLayoutInfo.example }}
          </p>
          <p class="mb-1 fw-bold text-uppercase key-reports-label">
            Key Reports
          </p>
          <ul class="mb-0 key-reports-list">
            <li *ngFor="let report of selectedLayoutInfo.reports">
              {{ report }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="form-check form-switch mb-1 coaching-toggle"
      placement="top"
      container="body"
      *ngIf="showCoachingToggle"
      [ngbTooltip]="isEditMode ? coachingLockedTooltip : ''"
      [attr.tabindex]="isEditMode ? 0 : null">
      <input
        id="sessionTypeCoaching"
        class="form-check-input"
        type="checkbox"
        role="switch"
        formControlName="isCoaching" />
      <label class="form-check-label fw-bold" for="sessionTypeCoaching"
        >Coaching Session</label
      >
      <p class="help-text mb-0">
        Flag this session type as a coaching session for reporting and
        filtering.
      </p>
    </div>
  </form>

  <div class="w-100 d-flex justify-content-between" footerContent>
    <button (click)="closeModal()" class="btn btn-reset" type="button">
      Cancel
    </button>
    <button
      (click)="onSubmit()"
      class="btn btn-primary"
      type="button"
      [disabled]="!form || form.invalid || submitLoading">
      {{ isEditMode ? "Save Changes" : "Create Session Type" }}
    </button>
  </div>
</app-modal>
